module.exports = __webpack_public_path__ + "img/logo.38cb45f3.jpeg";